module.exports = __webpack_public_path__ + "img/description3.05710882.jpg";